import { createReducer } from '@reduxjs/toolkit';
import { IUser } from '../../../interfaces/user';
import AuthService from '../../../services/AuthService';
import { getUserAction, getUserErrorAction, resetUserAction } from '../actions/UserActions';

export interface ReduxUserState {
  user?: IUser;
  userLoaded?: boolean;
  userNetworkError?: boolean;
  authenticated?: boolean;
}

const initialState: ReduxUserState = {
  authenticated: AuthService.loggedIn(),
  user: undefined,
  userLoaded: false,
  userNetworkError: false,
};

const userReducer = createReducer(initialState, (builder) =>
  builder
    .addCase(getUserAction, (state, action) => ({
      user: action.payload,
      userLoaded: true,
      authenticated: true,
      userNetworkError: false,
    }))
    .addCase(getUserErrorAction, (state) => ({
      ...state,
      userNetworkError: true,
    }))
    .addCase(resetUserAction, () => ({
      authenticated: false,
      userLoaded: false,
      user: undefined,
      userNetworkError: false,
    })),
);

export default userReducer;
